import { Injectable, inject, WritableSignal, signal } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { ENV } from '../../../../../environments/environment';
import { catchError, throwError } from 'rxjs';




@Injectable({
  providedIn: 'root'
})
export class PwaService {

  private swPush: SwPush = inject(SwPush);

  public canInstallApp: WritableSignal<boolean> = signal(false);
  private deferredPrompt: any;


  constructor() {
    this.$listenBeforeToInstall();
  }


  private $listenBeforeToInstall(): void {
    window.addEventListener('beforeinstallprompt', event => {
      event.preventDefault();
      this.deferredPrompt = event;
      this.canInstallApp.set(true);
      navigator.mediaDevices
    });
  }


  public installApp(): Promise<void> {
    if (!this.deferredPrompt) {
      return Promise.reject('No prompt event available');
    }

    return this.deferredPrompt.prompt().then(() => {
      this.deferredPrompt = null;
      this.canInstallApp.set(false);
      return Promise.resolve('Ready');
    });
  }


  public subscribeToNotifications(identification: string): void {
    if (!this.swPush.isEnabled) {
      console.warn('🚫 Push notification no está disponible');
      return;
    }

    // this.swPush.requestSubscription({
    //   serverPublicKey: ENV.PWA.PUSH_NOTIFICATIONS.PUBLIC_KEY
    // })
    this.requestNotificationPermission().then(sub => {
      // console.log({ token: JSON.parse(JSON.stringify(sub)) });
      // this.sendSubscriptionToServer(identification, sub);
    }).catch(err => console.error('❌ Error al suscribirse:', err));
  }


  private sendSubscriptionToServer(identification: string, sub: PushSubscription) {
    // const mutation = gql`
    //   mutation SavePushSubscription($identification: ID!, $subscription: String!) {
    //     savePushSubscription(identification: $identification, subscription: $subscription)
    //   }
    // `;
    //
    // this.apollo.mutate({
    //   mutation,
    //   variables: {
    //     identification,
    //     subscription: JSON.stringify(sub)
    //   }
    // }).pipe(
    //   catchError((err: any) => {
    //     console.error('❌ Error al guardar subscripción', err)
    //     return throwError(err);
    //   })
    // ).subscribe(() => console.log('✅ Subscripción guardada'));
  }


  public async requestNotificationPermission() {
    if ('Notification' in window) {
      const registration: ServiceWorkerRegistration = await navigator.serviceWorker.ready,
            permission: NotificationPermission = await Notification.permission;

      if (permission === 'granted') {
        // this.getPushNotificationToken(registration);

      } else if (permission === 'default') {
        const result = await Notification.requestPermission();

        if (result === 'granted') {
          // this.getPushNotificationToken(registration);
          await registration.showNotification('¡Hola desde Servicios Hogar!', {
            body: 'Desde este momento podrás recibir notificaciones',
            icon: 'pwa/icon-72x72.png',
            dir: 'auto',
            silent: false,
            lang: 'es-CL',
            requireInteraction: true,
            tag: 'tag',
            badge: 'badge',
            data: {
              onActionClick: {
                default: {
                  operation: 'openWindow',
                  url: 'www.youtube.com'
                }
              }
            }
          });
        } else { console.warn('❌ Permiso de notificación denegado'); }
      }
    }
  }
}
